'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DELayout = exports.DELayoutFooter = exports.DELayoutMain = exports.DELayoutSide = exports.DELayoutContent = exports.DELayoutHeader = undefined;

var _propEq = require('ramda/src/propEq');

var _propEq2 = _interopRequireDefault(_propEq);

var _find = require('ramda/src/find');

var _find2 = _interopRequireDefault(_find);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _glamorous2.default.div({
  // sticky footer -> https://philipwalton.com/articles/normalizing-cross-browser-flexbox-bugs/
  display: 'flex',
  height: '100vh',
  flexDirection: 'column'
});

var WrapperContent = _glamorous2.default.div({
  display: 'flex',
  flexDirection: 'column',

  // sticky footer -> https://philipwalton.com/articles/normalizing-cross-browser-flexbox-bugs/
  flex: '1 0 auto'
}, function (_ref) {
  var isHome = _ref.isHome;
  return {
    backgroundColor: isHome ? _.Colors.BLUE2 : null,
    padding: (isHome ? '30px' : 0) + ' ' + _.Layout.PADDING,
    justifyContent: isHome ? 'center' : 'initial',
    alignItems: isHome ? 'center' : 'stretch'
  };
});

var WrapperInnerContent = _glamorous2.default.div({
  display: 'flex'
}, function (_ref2) {
  var isRtl = _ref2.isRtl,
      isNarrow = _ref2.isNarrow;
  return {
    paddingTop: isNarrow ? 0 : 20,
    direction: isRtl ? 'rtl' : 'ltr',
    flexDirection: isNarrow ? 'column' : 'row'
  };
});

var WrapperHeader = _glamorous2.default.div({});

var WrapperSide = _glamorous2.default.div({}, function (_ref3) {
  var isNarrow = _ref3.isNarrow;
  return {
    flex: isNarrow ? 1 : '0 0 ' + _.Layout.SIDE_WIDTH + 'px'
  };
});

var WrapperMain = _glamorous2.default.div({
  flex: 1
}, function (_ref4) {
  var isRtl = _ref4.isRtl,
      isNarrow = _ref4.isNarrow;
  return {
    paddingLeft: isRtl || isNarrow ? 0 : 20,
    paddingRight: isRtl && !isNarrow ? 20 : 0
  };
});

var WrapperFooter = _glamorous2.default.div({
  // sticky footer -> https://philipwalton.com/articles/normalizing-cross-browser-flexbox-bugs/
  flexShrink: 0
});

var DELayoutHeader = exports.DELayoutHeader = function DELayoutHeader(_ref5) {
  var children = _ref5.children;
  return children;
};
var DELayoutContent = exports.DELayoutContent = function DELayoutContent(_ref6) {
  var children = _ref6.children;
  return children;
};
var DELayoutSide = exports.DELayoutSide = function DELayoutSide(_ref7) {
  var children = _ref7.children;
  return children;
};
var DELayoutMain = exports.DELayoutMain = function DELayoutMain(_ref8) {
  var children = _ref8.children;
  return children;
};
var DELayoutFooter = exports.DELayoutFooter = function DELayoutFooter(_ref9) {
  var children = _ref9.children;
  return children;
};

var DELayout = exports.DELayout = function DELayout(_ref10) {
  var children = _ref10.children,
      isRtl = _ref10.isRtl,
      isHome = _ref10.isHome,
      isNarrow = _ref10.isNarrow;

  var mchildren = _react2.default.Children.toArray(children);
  var component = function component(vchildren) {
    return function (vtype) {
      return (0, _find2.default)((0, _propEq2.default)('type', vtype))(vchildren);
    };
  };
  var mcomponent = component(mchildren);

  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(
      WrapperHeader,
      null,
      mcomponent(DELayoutHeader)
    ),
    _react2.default.createElement(
      WrapperContent,
      { isRtl: isRtl, isHome: isHome },
      mcomponent(DELayoutContent),
      _react2.default.createElement(
        WrapperInnerContent,
        { isRtl: isRtl, isNarrow: isNarrow },
        _react2.default.createElement(
          WrapperSide,
          { isNarrow: isNarrow },
          mcomponent(DELayoutSide)
        ),
        _react2.default.createElement(
          WrapperMain,
          { isRtl: isRtl, isNarrow: isNarrow },
          mcomponent(DELayoutMain)
        )
      )
    ),
    _react2.default.createElement(
      WrapperFooter,
      null,
      mcomponent(DELayoutFooter)
    )
  );
};

DELayout.propTypes = {
  children: _propTypes2.default.node,
  isRtl: _propTypes2.default.bool,
  isHome: _propTypes2.default.bool,
  isNarrow: _propTypes2.default.bool
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-layout/index.js
// module id = 2016
// module chunks = 0